var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"secondaryNavigation"},[_c('secondaryNavigation',{attrs:{"list":_vm.list}})],1),_c('div',{staticClass:"boxContent"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }